import { useQuery } from "@tanstack/react-query";
import api from "../../services/apis/antecipeApi";

/** Item achatado do `GET …/:id/timeline` (BE-1g, spec §8.2 v3.1). */
export type TimelineItem = {
  type: "status" | "feedback" | "move";
  at: string;
  from: string | null;
  to: string | null;
  actor: string | null;
  actorType: string | null;
  reason: string | null;
  /** `false` quando o motivo foi desativado no catálogo; `null` quando não se aplica. */
  reasonActive: boolean | null;
  text: string | null;
  source: string | null;
};

type Raw = Record<string, unknown>;
const TYPES: TimelineItem["type"][] = ["status", "feedback", "move"];
const str = (v: unknown) => (v === undefined || v === null || v === "" ? null : String(v));

/** Defensivo: campo ausente = null; nada quebra se o BE ainda não tiver o campo. */
export function toTimelineItem(r: Raw): TimelineItem {
  return {
    type: TYPES.includes(r.type as TimelineItem["type"]) ? (r.type as TimelineItem["type"]) : "status",
    at: String(r.at ?? ""),
    from: str(r.from),
    to: str(r.to),
    actor: str(r.actor),
    actorType: str(r.actorType),
    reason: str(r.reason),
    reasonActive: typeof r.reasonActive === "boolean" ? r.reasonActive : null,
    text: str(r.text),
    source: str(r.source),
  };
}

export async function fetchTimeline(id: number): Promise<TimelineItem[]> {
  const body = (await api.get(`antecipebackoffice/advancepayment/${id}/timeline`)).data;
  const list = Array.isArray(body) ? body : Array.isArray(body?.data) ? body.data : [];
  return (list as Raw[]).map(toTimelineItem);
}

export const timelineKey = (id: number) => ["timeline", id] as const;

export function useTimeline(id: number, enabled: boolean) {
  return useQuery({ queryKey: timelineKey(id), queryFn: () => fetchTimeline(id), enabled });
}
